import { Tooltip } from '@cobliteam/ui/components';
import { Checkbox, Label } from '@cobliteam/ui/form';

import type { User } from '@cobliteam/common-types/src/user';

interface UserItemProps {
  listByEmail?: boolean;
  checked: boolean;
  user: User;
  unselectableMessage?: string;
  onChange: () => void;
}

const UserItem = ({ listByEmail, checked, onChange, user, unselectableMessage = '' }: UserItemProps) => {
  const { id, name, email } = user;

  return (
    <Tooltip enable={!user.active} content='O usuário não está ativo'>
      <div className='flex items-center gap-2'>
        <Checkbox disabled={Boolean(unselectableMessage) || !user.active} id={`${id}-${checked}`} key={`${id}-${checked}`} checked={checked} onCheckedChange={onChange} />
        <Label htmlFor={`${id}-${checked}`}>{listByEmail ? email : name}</Label>
      </div>
    </Tooltip>
  );
};
export default UserItem;
